import { createStore, applyMiddleware, combineReducers } from 'redux'
import { routerMiddleware, routerReducer } from 'react-router-redux'
import { browserHistory } from 'react-router'
import thunk from 'redux-thunk'
import { autoRehydrate } from 'redux-persist'
import { composeWithDevTools } from 'redux-devtools-extension'

// TODO: We should set up build params so that this is not enabled in prod
// Something like: process.env.ENABLE_DEVTOOLS ? composeWithDevTools : compose
const composeFn = composeWithDevTools

const createReduxStore = (reducers = {}, rehydratePersist = false, websocket = null) => {
  const combinedReducers = combineReducers({
    ...reducers,
    routing: routerReducer,
  })

  const preloadedState = undefined

  const enhancer = composeFn(
    applyMiddleware(
      routerMiddleware(browserHistory),
      websocket ? thunk.withExtraArgument({ emit: websocket.emit }) : thunk
    ),
    rehydratePersist ? autoRehydrate() : f => f
  )

  return createStore(combinedReducers, preloadedState, enhancer)
}

export default createReduxStore
